import { useEffect } from 'react';

// Discard on leave, local GET once on return. Never retry a provider POST.
export const useQuoteFocus=(invalidate,refresh)=>{
  useEffect(()=>{
    let inactive=false;
    const leave=()=>{if(!inactive){inactive=true;invalidate();}};
    const enter=()=>{
      if(inactive&&document.visibilityState==='visible'){
        inactive=false;refresh();
      }
    };
    const visibility=()=>{if(document.visibilityState==='hidden')leave();else enter();};
    window.addEventListener('blur',leave);
    window.addEventListener('focus',enter);
    document.addEventListener('visibilitychange',visibility);
    return()=>{
      window.removeEventListener('blur',leave);
      window.removeEventListener('focus',enter);
      document.removeEventListener('visibilitychange',visibility);
    };
  },[invalidate,refresh]);
};